import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Clock, ArrowRight, Tag } from 'lucide-react';
import { Card } from '@/components/ui/card';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { blogPosts } from '@/data/blogPosts';

export default function Blog() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="pt-24 pb-16 bg-slate-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-12"
          >
            <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4" data-testid="blog-title">
              AirVia Travel Blog
            </h1>
            <p className="text-lg text-slate-600">Tips, guides, and insights to save on domestic flights</p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post, index) => (
              <motion.div
                key={post.id}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Link to={`/blog/${post.id}`} data-testid={`blog-card-${post.id}`}>
                  <Card className="border-slate-200 hover:border-amber-400 transition-colors h-full overflow-hidden group">
                    <div className="bg-slate-900 p-6">
                      <span className="inline-block bg-amber-600/20 text-amber-400 text-xs font-medium px-3 py-1 rounded-full mb-3">
                        {post.category}
                      </span>
                      <h2 className="text-xl font-bold text-white group-hover:text-amber-400 transition-colors">
                        {post.title}
                      </h2>
                    </div>
                    <div className="p-6">
                      <p className="text-slate-600 text-sm mb-4">{post.excerpt}</p>
                      <div className="flex items-center justify-between text-xs text-slate-400">
                        <span className="flex items-center gap-1">
                          <Clock className="w-3 h-3" /> {post.readTime}
                        </span>
                        <span>{new Date(post.date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                      </div>
                    </div>
                  </Card>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
